const Components = {
    APPLICATION: 'application',
    ERROR: 'error',
    LOGIN: 'login',
    REGISTER: 'register',
    LOGOUT: 'logout',
    FORGOT_PASSWORD: 'forgot_password',
    PWA: 'pwa',
    PARTICIPATIONS: 'participations',
    QUESTIONNAIRES: 'questionnaires',
    QUESTIONNAIRE: 'questionnaire',
    PRACTICE_SITE: 'practice_site',
    SET_LANGUAGE: 'set_language',
    CAPACITYTEST: 'capacitytest',
    COUNTDOWN: 'countdown',
    AMEND_DETAILS: 'amend_details',
    ASSESSMENT_REPORT: 'assessmentReport',
    FEATURE_TOGGLES: 'feature_toggles',
    REPORTS: 'reports',
    REPORT: 'report',
    PROFILE: 'profile',
    SELF_REGISTRATION: 'self_registration'
};

export default Components;
